import { createSlice } from "@reduxjs/toolkit";
import { Activity } from "../../../utils/activity-log";
import { Pagination } from "../../../utils/api";

type InitialState = {
  data: Activity[];
  meta: Pagination | null;
  isLoading: boolean;
};

const initialState: InitialState = {
  data: [],
  meta: null,
  isLoading: false,
};

const activityPageSlice = createSlice({
  name: "activityPageSlice",
  initialState,
  reducers: {
    request: (state, action) => {
      state.isLoading = true;
    },
    setData: (state, action) => {
      const { data, meta } = action.payload;

      state.data = [...state.data, ...data];

      state.meta = meta;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    reset: () => initialState,
  },
});

export default activityPageSlice;
